import React, { useEffect, useRef } from 'react';

import { useRouter } from 'next/router';
import Script from 'next/script';
import PropTypes from 'prop-types';

import config from '../../config/default';

const defaultCustomerDetail = {};
const defaultCallback = () => {};
const defaultOptions = {};
const src = config.public.webchatScriptUrl;

function getEndpointKey(endpointKeys, path) {
  return endpointKeys.byRoute?.[path] || endpointKeys.default;
}

export default function CognigyWebChatSnippet({
  buCode = '',
  callback = defaultCallback,
  cogRegion = '',
  customerDetail = defaultCustomerDetail,
  endpointKeys = {},
  options = defaultOptions,
}) {
  const router = useRouter();
  const buCodeRef = useRef(buCode);
  const cogRegionRef = useRef(cogRegion);
  const customerDetailRef = useRef(customerDetail);
  const endpointKeysRef = useRef(endpointKeys);
  const optionsRef = useRef(options);
  const callbackRef = useRef(callback);

  useEffect(() => {
    const endpointKey = getEndpointKey(
      endpointKeysRef.current,
      router.pathname
    );

    const tryInitWebchat = () => {
      if (window?.initWebchat && !window.webchat) {
        window
          .initWebchat(`https://endpoint-app-us.cognigy.ai/${endpointKey}`, {
            settings: {
              startBehavior: {
                startBehavior: 'injection',
                getStartedText: 'Get Started',
                getStartedData: {
                  name: customerDetailRef.current?.name,
                  customerId: customerDetailRef.current?.customerId,
                  buCode: buCodeRef.current,
                  cogRegion: cogRegionRef.current,
                },
              },
              ...optionsRef.current,
            },
          })
          .then((webchat) => {
            window.webchat = webchat;
            callbackRef.current();
          });
      }
    };

    if (window?.webchat?.getConversationId) {
      window.webchat.getConversationId().then((conversationId) => {
        if (!conversationId) {
          tryInitWebchat();
        }
      });
    } else {
      tryInitWebchat();
    }
  }, [router.pathname]);

  return <Script src={src} strategy="lazyOnload" />;
}

CognigyWebChatSnippet.propTypes = {
  buCode: PropTypes.string,
  callback: PropTypes.func,
  cogRegion: PropTypes.string,
  customerDetail: PropTypes.object,
  endpointKeys: PropTypes.object,
  options: PropTypes.object,
};
